import { ILocation } from '@rbi-ctg/frontend';
import { cornersForPoint, hypotenuse } from 'utils/geometry';

export const bounds = ({
  location,
  zoom,
  ref
}: {
  location: ILocation;
  zoom: number;
  ref: HTMLDivElement | null;
}) => {
  if (!ref) {
    return null;
  }
  const mapBounds = ref.getBoundingClientRect();
  const diagonal = hypotenuse(mapBounds.width, mapBounds.height);
  return cornersForPoint(location.lat, location.lng, zoom, diagonal);
};
